import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

export default {
    methods: {
      do_print (page_structure, metadata){
        if (typeof page_structure === 'undefined' || typeof metadata === 'undefined') {
          console.warn('[print page] no page_structure or no metadata provided')
          return
        }

        pdfMake.vfs = pdfFonts;
        // pdfMake.vfs = pdfFonts.pdfMake.vfs
        /*字體設定*/
        pdfMake.fonts = {
          /*Roboto為默認字體*/  
          Roboto: {
            normal: 'Roboto-Regular.ttf',
            bold: 'Roboto-Medium.ttf',
            italics: 'Roboto-Italic.ttf',
            bolditalics: 'Roboto-Italic.ttf' 
          },
          /*加入我們自己的中文的字體*/
          MSFont: {
            normal: 'MingLiU.ttf',
            bold: 'MingLiU.ttf',
            italics: 'MingLiU.ttf',
            bolditalics: 'MingLiU.ttf', 
          } 
        }

        let print_list = this.get_print_structure(page_structure, metadata)
        let docDefinition = {
          content: print_list,
          defaultStyle: {font: 'MSFont'},
          info:{title: `${metadata.title}-列印`}
        };
        // pdfMake.createPdf(docDefinition).open()
        pdfMake.createPdf(docDefinition).download(`${metadata.title}-列印`)

      },
      get_print_structure(page_structure, metadata){
        let print_column = page_structure

        let print_content = []
        for(let prop in print_column['fields']){
          print_content.push({
            text: print_column['fields'][prop].name , style: 'header' ,fontSize: 15, bold: true
          })

          let sub_list = []
          for(let sub_prop in print_column['fields'][prop]['fields']){
            

            if(print_column['fields'][prop]['fields'][sub_prop]['display']['name'] !== "林班"){
              sub_list.push(
                [
                  print_column['fields'][prop]['fields'][sub_prop]['display']['name'],
                  metadata[print_column['fields'][prop]['fields'][sub_prop]['source']['key']]
                ]
              )
            }else{
              let forest_array = ''

              if(metadata['business_district_forest'] === null || metadata['business_district_forest'].length === 0){
                forest_array = ''
              }else{
                forest_array = Object.values(metadata[print_column['fields'][prop]['fields'][sub_prop]['source']['key']][0])
              }
              
              sub_list.push(
                [
                  print_column['fields'][prop]['fields'][sub_prop]['display']['name'],
                  forest_array
                ]
              )
            }
          }

          print_content.push({
            style: 'tableExample',
            table: {
              widths: [100, '*'],
              body: sub_list
            }
          })
        }

        return print_content

      }
    }
}